import { buildModelManager } from "../builder.js";
const DefaultQuickQaProtocolRouteSelection = {
  __typename: true,
  id: true,
  agencyAliases: true,
  agencyName: true,
  createdAt: true,
  isActive: true,
  metadata: true,
  priority: true,
  scopeType: true,
  stateCode: true,
  stateName: true,
  title: true,
  updatedAt: true,
  vectorStoreId: true
};
const modelApiIdentifier = "quickQaProtocolRoute";
const pluralModelApiIdentifier = "quickQaProtocolRoutes";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickQaProtocolRouteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickQaProtocolRouteSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaProtocolRouteSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaProtocolRouteSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaProtocolRouteSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaProtocolRouteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaProtocolRouteSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "quickQaProtocolRouteGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QuickQaProtocolRouteManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQuickQaProtocolRouteSelection,
  operations
);
export {
  DefaultQuickQaProtocolRouteSelection,
  QuickQaProtocolRouteManager
};
//# sourceMappingURL=QuickQaProtocolRoute.js.map
